import { useEffect, useState } from 'react';

import ButtonCustom from '../../pages/UiElements/ButtonCustom';

import RealtimeChannelList from './RealtimeChannelList';

import {
  UserRealtimeChannelDTO,
} from '../../types/realtime';

import FormModal from '../Modals/FormModal';
import { UserRealtimeSubscriptionItemDTO } from '../../types/realtime/UserRealtimeSubscriptionItemDTO';

interface Props {
  open: boolean;

  user: UserRealtimeChannelDTO | null;

  onClose: () => void;

  onSave: (channels: UserRealtimeSubscriptionItemDTO[]) => void;
}

const RealtimeSubscriptionModal = ({ open, user, onClose, onSave }: Props) => {
  const [channels, setChannels] = useState<UserRealtimeSubscriptionItemDTO[]>(
    []
  );

  useEffect(() => {
    if (user) {
      setChannels(user.channels ?? []);
    }
  }, [user]);

  const handleToggle = (channelId: number, subscribed: boolean) => {
    setChannels((prev) =>
      prev.map((channel) =>
        channel.channelId === channelId
          ? {
              ...channel,
              subscribed,
            }
          : channel
      )
    );
  };

  if (!user) {
    return null;
  }

  const enabledChannels = channels.filter(
    (channel) => channel.subscribed
  ).length;

  const totalChannels = channels.length;

  const roleNames =
    user.roles?.map((role) => role.name).join(', ') ?? 'Sin rol';

  return (
    <FormModal
      isOpen={open}
      onClose={onClose}
      title="Configuración de Suscripciones Realtime"
      maxWidth="max-w-4xl"
    >
      {/* Información usuario */}

      <div
        className="
          bg-gray-1
          mb-6
          rounded-sm
          border
          border-stroke
          p-5
          dark:border-strokedark
          dark:bg-meta-4
        "
      >
        <div
          className="
            flex
            flex-col
            gap-2
            md:flex-row
            md:items-center
            md:justify-between
          "
        >
          <div>
            <h3
              className="
                text-lg
                font-semibold
                text-black
                dark:text-white
              "
            >
              {user.fullName}
            </h3>

            <p
              className="
                text-sm
                text-body
                dark:text-bodydark
              "
            >
              @{user.username}
            </p>

            <p
              className="
                text-sm
                text-body
                dark:text-bodydark
              "
            >
              {user.email}
            </p>

            <span
              className="
                mt-2
                inline-flex
                rounded-full
                bg-primary
                bg-opacity-10
                px-3
                py-1
                text-xs
                font-medium
                text-primary
              "
            >
              {roleNames}
            </span>
          </div>

          <div className="text-right">
            <p
              className="
                text-sm
                text-body
                dark:text-bodydark
              "
            >
              Canales suscritos
            </p>

            <div
              className="
                mt-1
                inline-flex
                rounded-full
                bg-success
                bg-opacity-10
                px-4
                py-2
                text-sm
                font-semibold
                text-success
              "
            >
              {enabledChannels} / {totalChannels}
            </div>
          </div>
        </div>
      </div>

      {/* Lista */}

      <RealtimeChannelList channels={channels} onToggle={handleToggle} />

      {/* Footer */}

      <div
        className="
          mt-6
          flex
          justify-end
          gap-3
          border-t
          border-stroke
          pt-5
          dark:border-strokedark
        "
      >
        <ButtonCustom text="Cancelar" variant="dark" onClick={onClose} />

        <ButtonCustom
          text="Guardar Configuración"
          iconKey="save"
          variant="primary"
          onClick={() => onSave(channels)}
        />
      </div>
    </FormModal>
  );
};

export default RealtimeSubscriptionModal;
